import { CityFeature } from "@/schemas/city-schema";

interface Params {
	userPosition: {
		latitude: number;
		longitude: number;
	};
	kuwaitCity: CityFeature[];
}

export const getUserLocation = () => {
	return new Promise<{ latitude: number | null; longitude: number | null }>(
		(resolve) => {
			if (!navigator.geolocation) {
				resolve({ latitude: null, longitude: null });
				return;
			}

			navigator.geolocation.getCurrentPosition(
				(position) => {
					resolve({
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
					});
				},
				() => {
					resolve({ latitude: null, longitude: null });
				},
			);
		},
	);
};

const getDistance = (
	lat1: number,
	lon1: number,
	lat2: number,
	lon2: number,
) => {
	const R = 6371;
	const toRad = (value: number) => (value * Math.PI) / 180;

	const dLat = toRad(lat2 - lat1);
	const dLon = toRad(lon2 - lon1);

	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(toRad(lat1)) *
			Math.cos(toRad(lat2)) *
			Math.sin(dLon / 2) *
			Math.sin(dLon / 2);

	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

	return R * c;
};

export const getClosestPosition = ({
	userPosition,
	kuwaitCity,
}: Params): CityFeature | null => {
	let closestCity: CityFeature | null = null;
	let minDistance = Infinity;

	kuwaitCity.forEach((city) => {
		const [lng, lat] = city.geometry.coordinates.map(Number);

		const distance = getDistance(
			userPosition.latitude,
			userPosition.longitude,
			lat,
			lng,
		);

		if (distance < minDistance) {
			minDistance = distance;
			closestCity = city;
		}
	});

	return closestCity;
};
